import { useQuery } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'

import { Loading, Trans } from '@/components'
import { formatCompactNumber } from '@/utils/formatter'

import { fetchRouteBillingSummary } from '../api'
import { ModelRoute } from '../types'

interface RouteBillingProps {
  route: ModelRoute
}

export function RouteBilling({ route }: RouteBillingProps) {
  const navigate = useNavigate()

  const { data, isLoading } = useQuery({
    queryKey: ['routeBillingSummary', route.resID],
    queryFn: () => fetchRouteBillingSummary(route.resID),
  })

  if (isLoading || !data) {
    return (
      <div className="bg-panel-gray-100 rounded-lg flex items-center justify-center p-8">
        <Loading />
      </div>
    )
  }

  return (
    <div className="bg-panel-gray-100 rounded-lg p-4 flex flex-col gap-4 t-sm text-tertiary">
      <div className="grid grid-cols-3 gap-4">
        <div className="space-y-1">
          <div className="t-xs text-secondary">
            <Trans ns="modelRoute" i18nKey="detail.billing.totalRequests">
              Total Requests
            </Trans>
          </div>
          <div className="t-sb text-primary">{formatCompactNumber(data.totalRequests)}</div>
        </div>
        <div className="space-y-1">
          <div className="t-xs text-secondary">
            <Trans ns="modelRoute" i18nKey="detail.billing.totalTokens">
              Total Tokens
            </Trans>
          </div>
          <div className="t-sb text-primary">{formatCompactNumber(data.totalTokens, 2)}</div>
        </div>
        <div className="space-y-1">
          <div className="t-xs text-secondary">
            <Trans ns="modelRoute" i18nKey="detail.billing.totalCost">
              Total Cost
            </Trans>
          </div>
          <div>
            <span className="t-sb text-primary">{data.totalCost}</span>{' '}
            <span className="text-secondary">
              <Trans ns="modelRoute" i18nKey="table.credits">
                Credits
              </Trans>
            </span>
          </div>
        </div>
      </div>

      <div className="h-px bg-neutral-200" />

      <div
        className="t-sb text-highlight cursor-pointer w-fit"
        onClick={() => navigate(`/model-route/billing?route=${route.resID}`)}
      >
        <Trans ns="modelRoute" i18nKey="detail.viewDetail">
          View Detail
        </Trans>
      </div>
    </div>
  )
}
